import { getFormattedPeriod } from 'packages/common/utils/format';

const mapAllOptionReturnValue = (show, option) => {
  return show && option && option !== '0' ? option : null;
};

export const mapReportFilters = (filters, options) => {
  const {
    showStockingSelect,
    showJobDescriptionSelect,
    showWorkerSelect,
    showDateMonthPeriod,
    showDateYearPeriod,
    showDescription,
    showDatePeriod,
    showEventSelect,
    showGroupBy,
    showOrderBy,
  } = options;

  const {
    stocking,
    jobDescription,
    worker,
    dateMonthPeriod,
    dateYearPeriod,
    description,
    datePeriod,
    events,
    orderBy,
    groupBy,
    collaboratorType,
  } = filters;

  return {
    stocking: mapAllOptionReturnValue(showStockingSelect, stocking),
    jobDescription: mapAllOptionReturnValue(showJobDescriptionSelect, jobDescription),
    worker: mapAllOptionReturnValue(showWorkerSelect, worker) ? worker : null,
    collaboratorType,
    dateMonthPeriod: showDateMonthPeriod ? getFormattedPeriod(dateMonthPeriod) : null,
    dateYearPeriod: showDateYearPeriod ? dateYearPeriod : null,
    description: showDescription ? description : null,
    datePeriod: showDatePeriod ? datePeriod : null,
    events: events ? mapAllOptionReturnValue(showEventSelect, [events]) : null,
    orderBy: showOrderBy ? orderBy : null,
    groupBy: showGroupBy ? groupBy : null,
  };
};
